// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationProcedureId } from './FermentationProcedure';
import { fermentationStatusEnum } from './FermentationStatusEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationProcedureTaskId = (z.number());
export const fermentationProcedureTask = z.object({
    id: fermentationProcedureTaskId,
    procedure_id: fermentationProcedureId,
    title: z.string(),
    instructions: z.string().nullable(),
    target_status: fermentationStatusEnum.nullable(),
    is_optional: z.boolean(),
    display_order: z.number(),
    created_at: z.date(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    calibration_target_key: z.string().nullable(),
});
export const fermentationProcedureTaskInitializer = z.object({
    id: fermentationProcedureTaskId.optional(),
    procedure_id: fermentationProcedureId,
    title: z.string(),
    instructions: z.string().optional().nullable(),
    target_status: fermentationStatusEnum.optional().nullable(),
    is_optional: z.boolean().optional(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    calibration_target_key: z.string().optional().nullable(),
});
export const fermentationProcedureTaskMutator = z.object({
    id: fermentationProcedureTaskId.optional(),
    procedure_id: fermentationProcedureId.optional(),
    title: z.string().optional(),
    instructions: z.string().optional().nullable(),
    target_status: fermentationStatusEnum.optional().nullable(),
    is_optional: z.boolean().optional(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    calibration_target_key: z.string().optional().nullable(),
});
//# sourceMappingURL=FermentationProcedureTask.js.map